import type { FeedbackAttachment } from '@/common/apis/feedback'

export function isFeedbackImageType(type?: string | null) {
  return Boolean(type && type.startsWith('image/'))
}

export function isFeedbackVideoType(type?: string | null) {
  return Boolean(type && type.startsWith('video/'))
}

type Previewable = Pick<FeedbackAttachment, 'fileType' | 'fileUrl'>

export function feedbackImagePreviewList(attachments?: Previewable[] | null) {
  return (attachments || [])
    .filter((item) => isFeedbackImageType(item.fileType) && item.fileUrl)
    .map((item) => String(item.fileUrl))
}

export function feedbackImagePreviewIndex(attachments: Previewable[] | undefined | null, url?: string) {
  const list = feedbackImagePreviewList(attachments)
  const index = list.findIndex((item) => item === url)
  return index >= 0 ? index : 0
}
